import * as yup from 'yup';

export const connectToPaddleFormValidationSchema = (t: any) => yup.object({
  bearerToken: yup
    .string()
    .required(t('tokenIsRequired')),
});
